import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { NgxMasonryComponent } from './ngx-masonry/ngx-masonry.component';
import { NgxMasonryDirective } from './ngx-masonry/ngx-masonry.directive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from '../../node_modules/ngx-bootstrap/carousel';

@NgModule({
  declarations: [
    AppComponent,
    NgxMasonryComponent,
    NgxMasonryDirective,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CarouselModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts